import {Subscription} from 'rxjs';
import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {LayoutConfigService, SplashScreenService, TranslationService} from './core/_base/layout';
import {locale as enLang} from './core/_config/i18n/en';
import {locale as chLang} from './core/_config/i18n/zh';
import {locale as jpLang} from './core/_config/i18n/ja';
import {locale as mmLang} from './core/_config/i18n/my';
import {locale as vtLang} from './core/_config/i18n/vi';
import {locale as esLang} from './core/_config/i18n/es';
import { SwPush } from '@angular/service-worker';

const extractQueryString = (url: string): string => {
    return url.split("?")[0];
}

@Component({
    selector: 'body[kt-root]',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'Order Go!';

    loader: boolean;

    previousOrigin = "";

    private unsubscribe: Subscription[] = [];

    constructor(private translationService: TranslationService,
                private router: Router,
                private layoutConfigService: LayoutConfigService,
                private splashScreenService: SplashScreenService,
                private swPush: SwPush) {

        // Register all translations
        this.translationService.loadTranslations(enLang, chLang, jpLang, mmLang, vtLang, esLang);
        // Make sure that the language is selected and available
        const language = this.translationService.getSelectedLanguage();
        this.translationService.setLanguage(language);
    }

    ngOnInit(): void {
        const layoutConfig = this.layoutConfigService.getConfig();
        this.loader = layoutConfig.loader.enabled;
        const routerSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.splashScreenService.hide();
                setTimeout(() => {
                    document.body.classList.add('kt-page--loaded');
                }, 500);
                // クエリパラメータが変わっただけではスクロールはしない。
                const origin = extractQueryString(event.url);
                if (origin === this.previousOrigin) {
                    this.previousOrigin = origin;
                    // ページが変わったのでスクロールする。
                    window.scrollTo(0, 0);
                }
            }
        });
        // web pushのクリックイベントを拾う公式のやり方は以下のようであるが、うまく動いてない（もしかして、別の場所に書くべきなのかもしれない）
        // さらにこの方法では、ブラウザがバックグラウンドの時に動かない。
        // angularには、ブラウザがバックグラウンドの時にweb pushのクリックイベントを拾う方法はないようなので、
        // 現状では、ngsw-worker.jsを直接書き換えている。
        // this.swPush.notificationClicks.subscribe(({action, notification}) => {
        //     console.warn(action, notification);
        //     this.router.navigate([notification.data.url]);
        // });
        this.unsubscribe.push(routerSubscription);
    }

    ngOnDestroy() {
        this.unsubscribe.forEach(sb => sb.unsubscribe());
    }
}
